import InsideDrawer, {
  IDrawerSettings,
} from '@src/shared/components/InsideDrawer';
import {
  PIEIconButton,
  PIEIconButtonModes,
  PIEIconButtonSizes,
} from '@src/shared/components/PIEIconButton';
import {
  DrawerType,
  useInsideDrawerActions,
} from '@src/shared/context/inside-drawer';
import React from 'react';
import { languages } from '@src/i18n';
import useActiveLanguage from '@src/shared/hooks/use-active-language';
import LanguagePanel from '@src/shared/components/LanguagePanel';
import { IconClose } from '@justeattakeaway/pie-icons-react';
import styles from './LanguagePanelDrawer.module.scss';
const drawerSettings: IDrawerSettings = {
  drawerVariant: 'persistent',
  fullSize: false,
  customClose: true,
  anchor: 'right',
};

const LanguagePanelDrawer = () => {
  const { setActiveInsideDrawer, setDrawerFlush } = useInsideDrawerActions();
  const { storedLanguageCode } = useActiveLanguage(true);
  return (
    <InsideDrawer
      type={DrawerType.LANGUAGE_LIST}
      titleI18nKey=""
      settings={drawerSettings}
    >
      <div className={styles.LanguagePanelDrawer}>
        <div className={styles.LanguagePanelDrawerHeader}>
          <IconClose onClick={setDrawerFlush} size="l" />
          <PIEIconButton
            size={PIEIconButtonSizes.MEDIUM}
            mode={PIEIconButtonModes.GHOST}
            onClick={() => {
              setActiveInsideDrawer(DrawerType.LANGUAGE_LIST);
            }}
            icon={
              <img
                src={languages[storedLanguageCode as string].img}
                alt="Toggle menu"
              />
            }
          />
        </div>
        <LanguagePanel onLanguageChanged={setDrawerFlush} />
      </div>
    </InsideDrawer>
  );
};

export default LanguagePanelDrawer;
